// B2BES [AST-359] - ADD Customization - Part of AST-359 EVO Payments
import { Wallet } from "@auer-steel/Services/AuerSteelApiModels";
import { getWalletsList } from "@auer-steel/Services/WalletService";
import { ACHWalletsDropdown } from "@auer-steel/Widgets/Common/PayfabricWallet/ACHWalletsDropdown";
import { CreateWallet } from "@auer-steel/Widgets/Common/PayfabricWallet/CreateWallet";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

export interface ACHWalletStyles {
    container?: GridContainerProps;
    fullWidthGridItem?: GridItemProps;
    achAccountsEmptyErrorText?: any;
}

type Props = {
    walletChangeHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void,
    onLoad: (e: string) => void,
    error: string | boolean,
}

export const styles: ACHWalletStyles = {
    container: {
        gap: 0,
    },
    fullWidthGridItem: {
        width: 12
    },
    achAccountsEmptyErrorText: {
        color: "#CD2037",
        weight: 600,
    },
}

export const ACHWalletSelection: React.FC<Props> = (props) => {
    const [wallets, setWallets] = React.useState<Wallet[]>([]);
    const [refreshNeeded, setRefreshNeeded] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [initialWalletId, setInitialWalletId] = React.useState("");
    const [achAccountsEmpty, setAchAccountsEmpty] = React.useState(false);

    const onWalletCreateHandler = () => setRefreshNeeded(true);

    React.useEffect(() => {
        getWalletsList().then(res => {
            res.successful && setWallets(res.result);
        })
            .catch(() => setAchAccountsEmpty(true))
            .finally(() => {
                setIsLoading(false);
            });

    }, [refreshNeeded]);

    // Wait for the render where wallets have been populated to set onLoad
    React.useEffect(() => {
        if (initialWalletId === "" && wallets && wallets[0]?.PaymentProfileId) {
            setInitialWalletId(wallets[0].PaymentProfileId);
            props.onLoad(wallets[0].PaymentProfileId);
        }

        if (wallets && wallets[0]) {
            setAchAccountsEmpty(false);
        }
    }, [wallets]);

    return (
        <GridContainer {...styles.container}>
            {isLoading && (
                <LoadingSpinner></LoadingSpinner>
            )}
            {props.error && achAccountsEmpty && (
                <GridItem {...styles.fullWidthGridItem}>
                    <Typography {...styles.achAccountsEmptyErrorText}>
                        {translate("ACH Account needed to proceed")}
                    </Typography>
                </GridItem>
            )}
            {!isLoading && !achAccountsEmpty && (
                <>
                    {wallets && wallets.length > 0 && <GridItem {...styles.fullWidthGridItem}>
                        <ACHWalletsDropdown wallets={wallets} walletChangeHandler={props.walletChangeHandler} error={props.error} />
                    </GridItem>}
                </>
            )}
            <GridItem {...styles.fullWidthGridItem} style={{marginTop: 10}}>
                <Link href="/manageACHAccounts">{translate("Manage ACH Accounts")}</Link>
            </GridItem>
        </GridContainer>
    );
};

const definition: WidgetDefinition = {
    group: "PayfabricWallet" as any,
};

const widgetModule: WidgetModule = {
    component: ACHWalletSelection,
    definition,
};

export default widgetModule;
